import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useLocationStore, usePipedriveStore, usePopupStore, useSearchStore } from "../..";
import SearchType from "../../interfaces/SearchType";
import { formatDate, formatNumber, formatPrice } from "../../utils/utils";
import commonStyles from "../Common.module.css";
import CompanyIcon from "../icons/CompanyIcon";
import MapPopupWithFlyTo from "../MapPopupWithFlyTo";
import popupStyles from "../Popup.module.css";

function LocationPopup({ id }: ILocationPopupProps) {
    const popupStore = usePopupStore();
    const locationStore = useLocationStore();
    const searchStore = useSearchStore();
    const pipedriveStore = usePipedriveStore();
    const location = useMemo(() => computed(() => locationStore.locations.find(l => l.id === id)), [id]).get();
    const company = useMemo(() => computed(() => location && pipedriveStore.organizations.find(o => o.id === location.pipedriveCompanyId)), [location]).get();

    if (locationStore.isLoading)
        return null;

    if (!location)
        return null;

    return (
        <MapPopupWithFlyTo
            longitude={location.centerPoint.longitude}
            latitude={location.centerPoint.latitude}
            closeButton={true}
            closeOnClick={false}
            onClose={() => popupStore.close()}
            anchor="bottom"
        >
            <div className={popupStyles.header}>
                <CompanyIcon color="white" />
                <div className={popupStyles.title}>
                    <div>{company?.name}</div>
                    <div>{location.address}</div>
                </div>
            </div>
            <div className={popupStyles.table}>
                <div className={popupStyles.tableItem}>
                    <div>Zoning</div>
                    <div>{location.zoning}</div>
                </div>
                <div className={popupStyles.tableItem}>
                    <div>Building Size</div>
                    <div>{!!location.buildingSize && `${formatNumber(location.buildingSize)} Sq-Ft`}</div>
                </div>
                <div className={popupStyles.tableItem}>
                    <div>Land Size</div>
                    <div>{!!location.landSize && `${formatNumber(location.landSize)} Acres`}</div>
                </div>
            </div>
            <div className={popupStyles.body}>
                <div>
                    <div>{location.ownerName}</div>
                    <div className={commonStyles.link} onClick={() => searchStore.setSearch(location.ownerAddress!, SearchType.Leads)}>{location.ownerAddress}</div>
                    {!!location.dateSold && !!location.salePrice && <div>{formatDate(new Date(location.dateSold))} - {formatPrice(location.salePrice)}</div>}
                </div>
            </div>
        </MapPopupWithFlyTo>
    );
}

export default observer(LocationPopup);

interface ILocationPopupProps {
    id: number;
}